import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ answer }) => {
  const data = {
    labels: answer.options,
    Response: true,
    datasets: [
      {
        label: "Votes",
        data: answer.answer,
        backgroundColor: [
          "#4A3AFF",
          "#2D5BFF",
          "#93AAFD",
          "#C6D2FD",
          "#E5EAFC",
          "#ADADAD",
          "#06032F"
        ],
        borderWidth: 1,
        pointStyle: "circle",
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 14, // set the font size
            family: "Inter", // set the font family
            weight: "bold", // set the font weight
          },
          padding: 20,
        },
      },
    },
  };
  return (
    <div className="piechart">
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
